import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path fillOpacity=".3" d="M2 22h20V2z" />, 'SignalCellular0Bar');
